var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapsPinNoSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_728_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84868 3.94954C2.25758 5.64764 1.26097 8.12129 1.29967 10.448C1.38048 15.3102 3.57211 17.1508 7.07693 23.8426C8.33943 26.7873 9.65711 29.9032 10.9103 35.0637C11.0845 35.8249 11.2543 36.532 11.3329 36.5933C11.4115 36.6546 11.5814 35.945 11.7555 35.1838C13.0087 30.0232 14.3264 26.9099 15.5889 23.9652C19.0937 17.2733 21.2853 15.4327 21.3662 10.5705C21.4049 8.24379 20.4058 5.76766 18.8147 4.06956C16.9971 2.12977 14.2557 0.694173 11.3329 0.634142C8.41018 0.574072 5.66625 2.00974 3.84868 3.94954Z",
    fill: "#B61F26",
    stroke: "#570F12",
    strokeWidth: 1.26462
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3329 14.4675C13.453 14.4675 15.1717 12.7489 15.1717 10.6288C15.1717 8.50867 13.453 6.79001 11.3329 6.79001C9.21284 6.79001 7.49414 8.50867 7.49414 10.6288C7.49414 12.7489 9.21284 14.4675 11.3329 14.4675Z",
    fill: "#570F12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 37.2185,
    fill: "white",
    transform: "translate(0.66626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsPinNoSale);
export default __webpack_public_path__ + "static/media/maps-pin-NoSale.34460251d9cd7755315bb7ca56f1b81a.svg";
export { ForwardRef as ReactComponent };